"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCancellablePromises = void 0;
const react_1 = require("react");
const useCancellablePromises = () => {
    const pendingPromises = react_1.useRef([]);
    const appendPendingPromise = react_1.useCallback((promise) => {
        pendingPromises.current = [...pendingPromises.current, promise];
    }, []);
    const removePendingPromise = react_1.useCallback((promise) => {
        pendingPromises.current = pendingPromises.current.filter((p) => p !== promise);
    }, []);
    const clearPendingPromises = react_1.useCallback(() => pendingPromises.current.map((p) => p.cancel()), []);
    const api = react_1.useMemo(() => ({
        appendPendingPromise,
        removePendingPromise,
        clearPendingPromises,
    }), [appendPendingPromise, clearPendingPromises, removePendingPromise]);
    return api;
};
exports.useCancellablePromises = useCancellablePromises;
//# sourceMappingURL=use-cancellable-promises.js.map